import {
  BookOpen,
  Calendar,
  ChartNoAxesCombined,
  ChevronRight,
  CircleHelp,
  ClipboardList,
  Clock,
  FileClock,
  FileUser,
  Folder,
  Headset,
  History,
  House,
  Inbox,
  LayoutDashboard,
  MessageSquareText,
  Plane,
  Presentation,
  ReceiptText,
  SearchX,
  Send,
  Server,
  Settings,
  Store,
  TrendingUp,
  TriangleAlert,
  User,
  UserPlus,
  Users,
  Utensils,
} from 'lucide-react';
import type { LucideProps } from 'lucide-react';

/** Matches the design prototype's sidenav icons (`text-[18px]`). */
export const SIDEBAR_NAV_ICON_SIZE = 18;

/**
 * MenuIcon: maps a menu config's icon name (a lucide-react component name) to its icon, so menu
 * configs can stay plain data.
 */
const iconMap = {
  BookOpen,
  Calendar,
  ChartNoAxesCombined,
  ChevronRight,
  CircleHelp,
  ClipboardList,
  Clock,
  FileClock,
  FileUser,
  Folder,
  Headset,
  History,
  House,
  Inbox,
  LayoutDashboard,
  MessageSquareText,
  Plane,
  Presentation,
  ReceiptText,
  SearchX,
  Send,
  Server,
  Settings,
  Store,
  TrendingUp,
  TriangleAlert,
  User,
  UserPlus,
  Users,
  Utensils,
} as const;

export type MenuIconName = keyof typeof iconMap;

interface MenuIconProps extends Omit<LucideProps, 'ref'> {
  /** Nothing is drawn without a (known) name. */
  name?: MenuIconName;
}

export const MenuIcon = ({ name, size = 24, ...props }: Readonly<MenuIconProps>) => {
  const Icon = name ? iconMap[name] : undefined;
  if (!Icon) return null;
  return <Icon size={size} {...props} />;
};
